import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import moment from 'moment';

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const AdvancedSearchListEvents = ({ title, reactTableData, ReactTableActions, setDataEvent, configPageSize, isAdvancedSearch }) => {
    const { t } = useTranslation('common');
    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        manualPageSize: [configPageSize],
        useActions: false
    };

    const tableConfigAdvancedSearch = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        manualPageSize: [configPageSize],
        useActions: true,
        actions: (data) => ReactTableActions({ data, setDataEvent })
    };

    const columnsDataAdvancedSearch = [
        {
            Header: "T.Doc",
            accessor: 'tip_documento',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Número de Documento",
            accessor: 'num_documento',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Nombre del Paciente",
            accessor: 'nombre_paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Fecha",
            accessor: 'start',
            Cell: row => (
                <label>
                    {moment(row.value).format("YYYY-MM-DD")}
                </label>
            )
        },
        {
            Header: "Hora Inicio",
            Cell: row => (
                <label>
                    {moment(row.row.original.start).format("h:mm:ss a")}
                </label>
            )
        },
        {
            Header: "Hora Final",
            Cell: row => (
                <label>
                    {moment(row.row.original.end).format("h:mm:ss a")}
                </label>
            )
        },
        {
            Header: "Profesional",
            accessor: 'nombres',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Estado",
            accessor: 'priority',
            Cell: row => (
                <b style={
                    row.value == "Reservada" ? { color: '#FD7E14' } :
                        row.value == "Cumplida" ? { color: '#28A745' } :
                            row.value == "Incumplida" ? { color: '#F6DA6E' } :
                                row.value == "Emergencia" ? { color: '#DC3545' } :
                                    null
                }>
                    {row.value}
                </b>
            )
        }
    ];

    const columnsDataFromCalendar = [
        /*
        {
            Header: " ",
            accessor: 'hour',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        */
        {
            Header: " ",
            accessor: 'medicalEvent'
        }
    ];

    const columnsData = isAdvancedSearch ? columnsDataAdvancedSearch : columnsDataFromCalendar;

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={isAdvancedSearch ? tableConfigAdvancedSearch : tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

AdvancedSearchListEvents.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default AdvancedSearchListEvents;
